import { identityClient } from '@/api/axiosClient'
import {
  IsUserProfileResponse,
  mapIsUserToUserProfile,
} from '@/api/identity/userMapper'
import { IMyAccessControl, ChangeMyProfilePayload } from '@/types/user'

// Matches IS UpdateUserSettingsRequest. measure is the string measure id
// ("1" = Metric, "2" = Imperial); zoneInfo is an IANA tz string.
export interface UpdateUserSettingsPayload {
  measure?: string
  locale?: string
  zoneInfo?: string
}

const usersApi = {
  // Returns axios response shape with mapped UserProfile in .data, so callers
  // can continue to destructure { data: user } identically to authApi.getProfile().
  async getMe() {
    const res = await identityClient.get<IsUserProfileResponse>('/api/users/me')
    return { ...res, data: mapIsUserToUserProfile(res.data) }
  },

  async getMyAccessControl() {
    return await identityClient.get<IMyAccessControl>(
      '/api/access-control/my-permissions',
    )
  },
  changeProfile(payload: ChangeMyProfilePayload) {
    const url = 'api/users/me/profile'
    return identityClient.put(url, payload)
  },

  // Persists measure / locale / zoneInfo to the IS. This is what GET /api/users/me
  // reads back, so it is the only write that actually clears the gmtTimeZone gate.
  async updateSettings(payload: UpdateUserSettingsPayload) {
    return await identityClient.put('/api/users/me/settings', payload)
  },

  // Records the newest changelog version the user has seen. The server only
  // moves it forward and returns the stored version as a plain string.
  async markChangelogSeen(version: string) {
    return await identityClient.put<string>('/api/users/me/changelog-seen', {
      version,
    })
  },
}

export default usersApi
